/**
 * KFUPM campus building locations
 * Coordinates are in decimal degrees (latitude, longitude)
 */

import { calculateDistance } from '../utils/locationUtils';

export const buildingLocations = {
  // Example coordinates - replace with actual KFUPM building coordinates
  "1": { name: "Building 1", latitude: 26.309196753993557, longitude: 50.140627015227835 },
  "2": { name: "Building 2", latitude: 26.309672485175874, longitude: 50.14103813057411 },
  "3": { name: "Building 3", latitude: 26.309480833019965, longitude: 50.14155160806405 },
  "4": { name: "Building 4", latitude: 26.30924642808321, longitude: 50.14224580286328 },
  "5": { name: "Building 5", latitude: 26.30892781179549, longitude: 50.14298146901621 },
  "6": { name: "Building 6", latitude: 26.30809019329409 , longitude: 50.143542111089324 },
  "7": { name: "Building 7", latitude: 26.307589662280463, longitude: 50.14364010950166 },
  "9": { name: "Building 9", latitude: 26.30656774984633, longitude: 50.14459674972429},
    "14": { name: "Building 14", latitude: 26.306571438347678, longitude: 50.14286863398459 },
    "16": { name: "Building 16", latitude: 26.309356112400486, longitude: 50.14138689589798 },
    "17": { name: "Building 17", latitude: 26.30666987598827, longitude: 50.143775451580495 },
    "18": { name: "Building 18", latitude: 26.305706226046055, longitude: 50.14348634014745 },
    "19": { name: "Building 19", latitude: 26.305706226046055, longitude: 50.14348634014745 },
  "22": { name: "Building 22", latitude: 26.30573588531559, longitude: 50.1465788334771 },
    "23": { name: "Building 23", latitude: 26.30573588531559, longitude: 50.1465788334771 },
  "24": { name: "Building 24", latitude: 26.304880543423774, longitude: 50.146638922082595 },
  "57": { name: "Building 57", latitude: 26.314537371648598, longitude: 50.14934178143789 },
    "58": { name: "Building 58", latitude: 26.314637586574058, longitude: 50.148614062492136 },
    "59": { name: "Building 59", latitude: 26.308466614702837, longitude: 50.14528116438943 },
    "63": { name: "Building 63", latitude: 26.310739459798988, longitude: 50.140878545196 },
    "75": { name: "Building 75", latitude: 26.310062645355696, longitude: 50.14111029804401},
    "76": { name: "Building 76", latitude: 26.30572429162158, longitude: 50.14787420333934 },
    "78": { name: "Building 78", latitude: 26.306214473429165, longitude: 50.148472642919835 },

  // Add more buildings as needed
};

// Get buildings sorted by distance from a given location
export const getNearbyBuildings = (userLat, userLng, maxDistance = 400) => {
  const buildings = Object.entries(buildingLocations).map(([id, data]) => {
    const distance = calculateDistance(userLat, userLng, data.latitude, data.longitude);
    return {
      building: id,
      name: data.name,
      distance,
      coordinates: { latitude: data.latitude, longitude: data.longitude }
    };
  });
  
  // Sort by distance and filter by max distance (in meters)
  return buildings
    .filter(b => b.distance <= maxDistance)
    .sort((a, b) => a.distance - b.distance);
};